import { z } from "zod";
import { isConfigurableToolId } from "./types.js";
export const penToolSettingsSchema = z.object({
    stroke: z.string().min(1).max(32),
    strokeWidth: z.number().finite().min(1).max(64),
    strokeLinecap: z.enum(["round", "butt", "square"]),
    strokeDash: z.enum(["solid", "dashed", "dotted"]).optional(),
});
export const eraserToolSettingsSchema = z.object({
    radius: z.number().finite().min(4).max(128),
});
const schemas = {
    pen: penToolSettingsSchema,
    eraser: eraserToolSettingsSchema,
};
export function parseToolPresetSettings(tool, settings) {
    return schemas[tool].parse(settings);
}
export function safeParseToolPresetSettings(tool, settings) {
    if (!isConfigurableToolId(tool)) {
        return { ok: false, error: "unknown_tool" };
    }
    const parsed = schemas[tool].safeParse(settings);
    if (!parsed.success) {
        return { ok: false, error: "invalid_settings" };
    }
    return { ok: true, tool, settings: parsed.data };
}
